const IMAGES = {
  v1_loader: '/assets/loader/loader_v1.gif',
  v2_loader: '/assets/loader/loader_v2.gif',
  logo: '/assets/images/logo.svg'
};

export default IMAGES;